var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._b({key:_vm.key,staticClass:"p-0",attrs:{"validation-behavior":"live","help":true,"value":_vm.computedValue,"fullObject":_vm.fullObject},on:{"input":_vm.handleInput,"update:fullObject":function($event){return _vm.$emit('update:fullObject', $event)}}},'FormulateInput',_vm.field,false))
}
var staticRenderFns = []

export { render, staticRenderFns }